import { styled } from 'styled-components'

export const Empty = styled.div`
	padding: 16px 0 8px;
	text-align: center;
	color: ${({ theme }) => theme.color.textSubtitle};
`
